import {getSubmit, postSubmit} from "ui-seeker/utils";
import i18n from "i18n";
import {DASHBOARD} from "app/@common/constants";
import {useSetHotel} from "app/@hooks";
import {useContextSelector} from "use-context-selector";
import {CommonFiltersSavedContext} from "../../../../../../context";
import {useToaster} from "ui-seeker/core";
import {useCommonFiltersItems, useCommonFiltersParity} from "../../../../../../hooks";
import {AppCurrencyContext, AppDatesContext, AppMarketContext} from "app/providers";
import {isValidFutureDate} from "../../../../../../@utils";
import {saveDashboardSettings} from "app/@utils/defaultFilters";

export default function useActions(preset_key) {
    const page = useContextSelector(CommonFiltersSavedContext, ({state}) => state.page)
    const updatePrevStateTable = useContextSelector(CommonFiltersSavedContext, ({updatePrevState}) => updatePrevState)
    const { showToaster } = useToaster()

    const {updateState: updateStateItems} = useCommonFiltersItems()
    const {updateState: updateStateParityItems} = useCommonFiltersParity()
    const setMarket = useContextSelector(AppMarketContext, ({updateState}) => updateState)
    const setCurrency = useContextSelector(AppCurrencyContext, ({updateState}) => updateState)
    const updateMonthYear = useContextSelector(AppDatesContext, ({ updateState }) => updateState)
    const updateStateSavedFilters = useContextSelector(CommonFiltersSavedContext, ({updateState}) => updateState)
    const { setHotel } = useSetHotel()

    const updateDashboard = (name, isDefault) => {
        showToaster.loading()
        postSubmit(`${DASHBOARD?.[page]?.EDIT}`, {
            preset_key,
            name,
            default: isDefault,
        }).then((data) => {
            updatePrevStateTable(prev => ({
                ...prev,
                dataSavedFilters: prev.dataSavedFilters.map(item => {
                    if (item.preset_key === preset_key) return data
                    if (isDefault) return {...item, default: false }
                    return item
                })
            }))
            if (isDefault) saveDashboardSettings(page?.toLowerCase(), {hasAppliedDefaults: false})
            showToaster.success(i18n.t('common:savedFilters.updated'))
        }).catch(() => {
            showToaster.error()
        })
    }

    const removeDashboard = () => {
        showToaster.confirm(i18n.t('common:savedFilters.confirmDelete'), {
            onSuccess: () => {
                postSubmit(`${DASHBOARD?.[page]?.REMOVE}`, {
                    preset_key,
                }).then(() => {
                    updatePrevStateTable(prev => ({...prev, dataSavedFilters: prev.dataSavedFilters.filter(item => item.preset_key !== preset_key) }))
                    showToaster.success(i18n.t('common:savedFilters.deleted'))
                })
            },
            onCancel: () => {
                showToaster.warning(i18n.t('common:savedFilters.cancelled'))
            }
        })
    }

    const applyFilters = (controller) => {
        controller()
        getSubmit(`${DASHBOARD?.[page]?.GET}/${preset_key}`).then(response => {
            const filters = response?.filters_raw

            const doApply = () => {
                if (filters?.items?.dateRange && isValidFutureDate(filters?.items?.dateRange)) updateMonthYear({monthYear: filters?.items?.dateRange})
                if (filters?.items?.dateRange === "custom") updateMonthYear({monthYear: "custom"})
                if (filters?.items?.customDateRange) {
                    const today = new Date()
                    filters.items.customDateRange = filters.items.customDateRange.map(d => {
                        const date = new Date(d)
                        return date < today ? today : date
                    })
                }
                updateStateItems(filters.items)
                updateStateParityItems(filters.parity)
                // Parity's market selector is clearable (CU-869fdfej3): a preset saved with "all markets" clears it
                if (filters?.market || page === 'PARITY') setMarket({market: filters?.market || null})
                filters?.currency && setCurrency({currency: filters.currency})
                updateStateSavedFilters({reloadPageFilters: true})
                showToaster.success(i18n.t('common:savedFilters.applied'))
            }

            if (response?.set_hotel) {
                setHotel(response.id_main_hotel).then(doApply)
                return
            }
            doApply()
        })
    }

    return {
        updateDashboard, removeDashboard, applyFilters,
    }
}